import { Injectable } from '@angular/core';
import { Http, Headers ,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS } from '../../config/url.servicio';

@Injectable()
export class ClientesProvider {

  constructor(public http: Http) {
  }

  buscar() {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      return this.http.get(`${url_servicio}/procedure?name=clientes`);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=clientes`)
        .map((data)=> data.json())
   }
  }
  buscarClientesPorEmpresa(companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientesPorEmpresa",
        parameters : {companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }



  buscarReferenciasFamiliares(companiasId:any,clientesId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarReferenciasFamiliares",
        parameters : {companiasId:companiasId,clientesId:clientesId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  buscarClientes(companiasId:any,clientesId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientes",
        parameters : {companiasId:companiasId,clientesId:clientesId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  buscarClientesPorIdentificacion(companiasId:any,identificacion:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientesPorIdentificacion",
        parameters : {companiasId:companiasId,identificacion:identificacion}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  buscarClientesReferenciasComerciales(companiasId:any,clientesId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientesReferenciasComerciales",
        parameters : {companiasId:companiasId,clientesId:clientesId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  eliminarReferencia(producto: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          clientesReferenciasFamiliaresId : producto.clientesReferenciasFamiliaresId,
          nombreTabla: "clientesReferenciasFamiliares"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosId=${producto.productosId}&nombreTabla=productos`, options)
  }
 }

 eliminarReferenciaComercial(producto: any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: producto.name,
      parameters : {
        name : "dataDynamicCrud",
        queHago: "E",
        clientesReferenciasComercialesId : producto.clientesReferenciasComercialesId,
        nombreTabla: "clientesReferenciasComerciales"
      }
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, data, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
      'Content-Type': 'application/json'
    })
    let options = new RequestOptions({
      headers: headers
    })

  return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosId=${producto.productosId}&nombreTabla=productos`, options)
}
}

  guardar(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientes",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, cliente, options)
        .map((data) => {
          data.json()}
        , error => {
          console.log(error)})
   }
  }


  guardarReferencia(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesReferenciasFamiliares",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, cliente, options)
        .map((data) => {
          data.json()}
        , error => {
          console.log(error)})
   }
  }


  clientesReferenciasComerciales(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesReferenciasComerciales",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, cliente, options)
        .map((data) => {
          data.json()}
        , error => {
          console.log(error)})
   }
  }


  guardarEntidades(entidades: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: entidades.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: entidades.name,
          ...entidades
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, entidades, options)
        .map((data) => {
          data.json()}
        , error => {
          console.log(error)})
   }
  }


  actualizar(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientes",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.put(`${url}/query`, cliente, options)
   }
  }

  eliminar(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientes",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

      return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&clientesId=${cliente.clientesId}&nombreTabla=clientes`, options)
   }
  }

  formatearCadena(cadena){
    let valorinicial = cadena.length
    let primero,segundo,ultimo
    primero = cadena.substr(0,4)
    segundo = cadena.substr(5,2)
    ultimo = cadena.substr(valorinicial - 2, valorinicial)
    if(valorinicial != 10){
      let recorrer = cadena.split('-')
      for(var i = 0; i < recorrer.length;i++) {
        if(i == 1 && recorrer[i].length == 1) {
          segundo = `0${recorrer[i]}`
        }
        if(i == 2 && recorrer[i].length == 1){
          ultimo = `0${recorrer[i]}`
        }
      }
    }
    return `${primero}-${ultimo}-${segundo}`
  }


  clientesReferenciasComercialesVarios(cliente: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: cliente.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: "clientesReferenciasComercialesVarios",
          ...cliente
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.post(`${url}/query`, cliente, options)
        .map((data) => {
          data.json()}
        , error => {
          console.log(error)})
   }
  }


  buscarClientesReferenciasComercialesVarios(companiasId:any,clientesId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientesReferenciasComercialesVarios",
        parameters : {companiasId:companiasId,clientesId:clientesId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  eliminarReferenciaComercialVarios(producto: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "E",
          clientesReferenciasComercialesVariosId : producto.clientesReferenciasComercialesVariosId,
          nombreTabla: "clientesReferenciasComercialesVarios"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })

    return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&productosId=${producto.productosId}&nombreTabla=productos`, options)
  }
  }

  buscarClientesPorEmpresaPaginado(companiasId:any,pagina:any,cantidadPaginar:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarClientesPorEmpresaPaginado",
        parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
      .map((data) => data.json())
   }
  }

  editarReferencia(producto: any) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: producto.name,
        parameters : {
          name : "dataDynamicCrud",
          queHago: "A",
          novedad:producto.novedad,
          numeroTelefono2:producto.numeroTelefono2,
          numeroTelefono:producto.numeroTelefono,
          parentezco:producto.parentezco,
          nombre:producto.nombre,
          clientesReferenciasFamiliaresId : producto.clientesReferenciasFamiliaresId,
          nombreTabla: "clientesReferenciasFamiliares"
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
 }

 buscarClientesPorEmpresaPaginadoInfinito(companiasId:any,pagina:any,cantidadPaginar:any,search:any=null){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarClientesPorEmpresaPaginadoInfinito",
      parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar,search:search}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
    .map((data) => data.json())
 }
}


buscarProductosPorEmpresaPaginado(companiasId:any,pagina:any,cantidadPaginar:any){
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let request = {
      name: "buscarProductosPorEmpresaPaginado",
      parameters : {companiasId:companiasId,pagina:pagina,cantidadPaginar:cantidadPaginar}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    return this.http.post(`${url_servicio}/procedure`, request, options);
  } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=buscarClientesPorEmpresa&companiasId=${companiasId}`)
    .map((data) => data.json())
 }
}



}



// WEBPACK FOOTER //
// ./src/providers/clientes/clientes.ts